define(['angular'], function (angular) {
    'use strict';

    return angular
        .module('layoutDirectives', [])
        .directive('onboardingWrapper', [
            '$interval',
            function ($interval) {
                return {
                    restrict: 'C',
                    scope: {},
                    link: function (scope, element, attrs) {
                        // We do not want body scrollbars included when a wrapper is visible
                        if (element.is(':visible')) {
                            $('body').css('overflow', 'hidden');
                        }

                        // Allow controllers to tell this directive when a wrapper has been shown or hidden.
                        scope.$on('onboardingWrapperShown', function () {
                            $('body').css('overflow', 'hidden');
                        });
                        scope.$on('onboardingWrapperHidden', function () {
                            $('body').css('overflow', 'auto');
                        });

                        /**
                         * Fall back to a timeout so we don't lose scrollbars
                         * forever if a controller neglects to indicate that a
                         * wrapper has been hidden.
                         */
                        var timeout = $interval(function () {
                            if (element.is(':visible')) {
                                $('body').css('overflow', 'hidden');
                            } else {
                                $('body').css('overflow', 'auto');
                            }

                            if (!document.contains(element[0])) {
                                $interval.cancel(timeout);
                            }
                        }, 5000);
                    },
                };
            },
        ]);
});
